module.exports = __webpack_public_path__ + "img/bg-star-wars.b5c7edc6.svg";